module.exports = __webpack_public_path__ + "img/instagram-brands.83aeebb5.svg";